import { useState } from "react";
import Item from "components/templates/projects/Item";
import ItemCreate from "components/templates/projects/Item/Create";
import useProjects from "apis/queries/project/useProjects";

// 프로젝트 목록
const List = () => {
  const [showMessage, setShowMessage] = useState(false);
  const projects = useProjects();

  return (
    <>
      <ul className="grid grid-cols-5 gap-5">
        <ItemCreate onVisibleMessage={() => setShowMessage(true)} />
        {projects?.map((project) => (
          <Item key={project.id} project={project} />
        ))}
      </ul>
      {showMessage && (
        <p className="text-red font-bold text-sm mt-4">
          프로젝트명을 정확히 기입해 주셔야 원활한 샘플 지원이 가능합니다.
        </p>
      )}
    </>
  );
};

export default List;
